import {ReadonlyURLSearchParams} from 'next/navigation'

export const broadcastMessage = (gameCode: string, state: string) => {
  const type = 'advertisement'
  try {
    window.postMessage({gameCode, state, type}, '*')
    window.parent.postMessage({gameCode, state, type}, '*')
  } catch (err) {
    console.log('brodcast err', err)
  }
}

export function decodeUriAndSanatizeName(name: string) {
  if (name) return decodeURIComponent(name).replace(/[^a-zA-Z0-9]/g, '')
  return ''
}

export function getGameWindow(): Window {
  const gameFrame = document.getElementById('game') as HTMLIFrameElement
  const gameWind = gameFrame && gameFrame.contentWindow ? gameFrame.contentWindow : (window.frames as any)?.game
  return gameWind
}

// Convert URLSearchParams to a plain object
export const getAllSearchParams = (searchParams: ReadonlyURLSearchParams | null) => {
  const paramsObject: Record<string, string> = {}
  searchParams?.forEach((value, key) => {
    paramsObject[key] = value
  })
  return paramsObject
}

// for login
export const constructName = (firstName: string, lastName: string) => {
  let fullName = firstName
  if (lastName) {
    fullName += ' ' + lastName
  }
  return fullName || ''
}
